import './FieldsetRow.scss'

import React from 'react'

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.legend
 */
const FieldsetRow = ({ children, legend }) => (
    <fieldset className="fieldset-row">
        <legend>{legend}</legend>
        {children}
    </fieldset>
)

export default FieldsetRow
